import React from 'react';
const rules = ['17 stations on a one mile round heavily wooded course.', 'Ammunition restrictions: Shot size allowed 7 1/2, 8 & 9 with a 1 1/8 ounce load maximum.', 'No more than 2 shells loaded at a time, shotguns carried unloaded with action open between stations.', 'All shells must be the same and within shot restrictions.', 'Open to the public on Saturday and Sunday, 10:00am to 3:00pm (Last line out at 2:00pm)', 'Cost is discounted for club members, Veterans & First Responders.', 'Special card available for high volume club members.', 'The course is open to FLSC club members Mon - Sat from 9:00am to dusk, and Sunday 9:00am to 5:00pm during summer hours.', 'The course is open to FLSC club members weekends only during winter hours. Saturday 9:00am - dusk and Sunday 9:00am to 5:00pm.', 'The clays course may be closed due to inclement weather at any time.', 'A short course orientation is required for new shooters.'];
export function CourseRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3274">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3275">
        <div className="mb-16" data-id="element-3276">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3277">
            Course Rules & Information
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3278">
            <ol className="space-y-4" data-id="element-3279">
              {rules.map((rule, index) => <li key={index} className="flex gap-4 items-start" data-id="element-3280">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold mt-0.5" style={{
                backgroundColor: 'rgba(30,61,47,0.08)',
                color: '#1e3d2f',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3281">
                    {index + 1}
                  </span>
                  <span className="text-base leading-relaxed pt-0.5" style={{
                color: '#2a2a2a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3282">
                    {rule}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </div>;
}